module.exports = __webpack_public_path__ + "static/media/credit-card.f49b0a78.svg";